import styled from "styled-components";

export const Arrow = styled.div`
  cursor: pointer;
  width: 44px;
  height: 84px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: #363636;
    }
  }

  &:before {
    display: none;
  }
`;
